import DashboardLayout from '../components/DashboardLayout';
import {
  deriveWorkbenchChart,
  deriveWorkbenchMetrics,
  deriveWorkbenchQuickAccess
} from '../data/mockHelpers';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

/**
 * Workbench (formerly `ExamplesDashboard`). Renders the dark-gold
 * dashboard shell for the `/app/dashboard` and `/examples/dashboard`
 * routes. Active sidebar pill is "工作台".
 */
function WorkbenchPage({
  settingsPanel,
  mobileMenu,
  sidebarOpen
}: BusinessPageProps) {
  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{
        heading: '让 HR 管理更智能',
        sub: '数据驱动 · 高效协同 · 赋能组织'
      }}
      metrics={deriveWorkbenchMetrics()}
      chart={deriveWorkbenchChart()}
      quickAccess={deriveWorkbenchQuickAccess()}
      activeSidebarId="workbench"
      settingsPanel={settingsPanel}
      mobileMenu={mobileMenu}
      sidebarOpen={sidebarOpen}
    />
  );
}

export default WorkbenchPage;